/**
 * 云端数据源：包装现有 HTTP api，行为与登录态一致。
 */
import { daynoteApi } from '../api/daynote';
import { groupApi } from '../api/group';
import { reportApi } from '../api/report';
import { userApi } from '../api/user';
import { transferApi } from '../api/transfer';
import type { DataSource } from './types';

export const cloudDataSource: DataSource = {
  getMonth: (month) => daynoteApi.getByMonth(month),
  getByDate: (date) => daynoteApi.getByDate(date),
  createItem: (date, data) => daynoteApi.createItem(date, data),
  updateItem: (itemId, data) => daynoteApi.updateItem(itemId, data),
  deleteItem: async (itemId) => {
    await daynoteApi.deleteItem(itemId);
  },
  updateOrder: async (dayNoteId, itemIds) => {
    await daynoteApi.updateOrder(dayNoteId, itemIds);
  },

  listGroups: () => groupApi.list(),
  createGroup: (data) => groupApi.create(data),
  updateGroup: (id, data) => groupApi.update(id, data),
  removeGroup: async (id) => {
    await groupApi.remove(id);
  },

  getReport: (type, date) => reportApi.get(type, date),

  getSetting: () => userApi.getSetting(),
  updateSetting: (patch) => userApi.updateSetting(patch),

  exportData: () => transferApi.exportAll(),
  importData: (payload) => transferApi.importAll(payload),
};
